import { render } from "./_form.vue?vue&type=template&id=05a07603"
import script from "./_form.vue?vue&type=script&lang=js"
export * from "./_form.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/users/_form.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05a07603"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05a07603', __exports__)) {
    console.log('reload')
    api.reload('05a07603', __exports__)
  }
  
  module.hot.accept("./_form.vue?vue&type=template&id=05a07603", () => {
    console.log('re-render')
    api.rerender('05a07603', render)
  })

}


export default __exports__